import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { AdService } from 'src/app/shared/services/ad.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AdUtils } from 'src/app/shared/utils/ad.utils';

import { AppLoadingService } from 'src/app/shared/services/apploading.service';
import { MaskApplierService, MaskPipe } from 'ngx-mask';
import { AvailableService } from 'src/app/shared/services/avaiable.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogActionComponent } from 'src/app/shared/components/dialog-action/dialog-action.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AbstractForm } from 'src/app/shared/utils/abstract-form';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { deepCopy } from '@angular-devkit/core/src/utils/object';
import { MatSelect } from '@angular/material/select';

declare var $: any;


@Component({
  selector: 'unit-amount-component',
  templateUrl: 'unit-amount.component.html',
  styleUrls: ['unit-amount.component.scss', '../../../realtor/components/view/ad-default.component.scss']
})
export class UnitAmountComponent extends AbstractForm implements OnInit, OnDestroy {

  @ViewChild('amount', { static: true }) amountField: ElementRef;
  @ViewChild('indexReference', { static: false }) indexReferenceField: ElementRef;
  @ViewChild('monthReference', { static: false }) monthReferenceField: MatSelect;

  dialogRef: MatDialogRef<any>;

  ad: any = {};
  id: any;
  blockSel;
  type = 'ad';
  error = false;
  loading = true;

  isAndroid = false;

  dialogRefIndex = null;


  formGroupUnit: FormGroup;

  formGroupUnitFields = {
    amountIndex: [''],
    amountOld: [''],
    amount: [''],
    resale: [false, Validators.required],
    preReserved: [false, Validators.required],
    status: [''],
    observation: ['']
  };

  unitStatus = {};
  unitStatusArray = [];

  mode: any = 'percentage';

  tableBlockSelected: any = [];

  customActionSheetOptions: any = {
    header: 'Selecione um bloco'
  };

  changed = false;

  applyBlocks: any = [];
  applyUnitTypes: any = [];

  valueReadjustment: any = false;
  indexReadjustment: any = false;

  formGroupFilter = this.formBuilder.group({
    block: [[]],
    unitType: [[]],
    status: [[11, 12, 13, 34]]
  });

  dataSel: any = {};
  unitSel: any = {};


  protected dataSubscription: Subscription;
  protected changedSubscription: Subscription;

  constructor(
    public adService: AdService,
    protected gs: GeneralService,
    private route: ActivatedRoute,
    public adUtils: AdUtils,
    protected as: AvailableService,
    protected als: AppLoadingService,
    protected ms: MaskApplierService,
    public dialog: MatDialog,
    protected formBuilder: FormBuilder,
    logger: LoggerService,


  ) {
    super(formBuilder, logger, false);

    this.as.mode = 'readjustment';

    this.dataSubscription = this.as.data$.subscribe(result => {
      if (this.as.mode == 'readjustment') {
        this.setBlockSel(false);
      }
    });
    this.changedSubscription = this.as.changed$.subscribe(result => {
      if (this.as.mode == 'readjustment') {
        this.changed = result;
      }
    });

    this.id = this.route.snapshot.paramMap.get('id');

  }

  updateControls() { }
  updateObject() { }

  goBack() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.as.readjustmentMode = this.mode;
    this.setDefault();

  }

  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
    this.changedSubscription.unsubscribe();
  }

  setDefaultSets() {
    this.applyBlocks = this.ad.data.blocks;

    this.applyUnitTypes = this.applyBlocks.map(item => {
      item.unitTypes = this.getUnitTypesByBlockId(item.id);
      return item;
    });


    this.formGroupUnit = this.formBuilder.group(this.formGroupUnitFields);

    this.setFieldsSubscribes(this.formGroupUnit);

    this.formDefault();
    this.formGroup.controls.correction_index.updateValueAndValidity({ emitEvent: false });
  }

  buildFormGroup(): FormGroup {
    let index: any = this.ad?.correction_index ? this.adService.indexes.filter(item => item.index_id == this.ad?.correction_index)[0] : this.adService.indexes[0];

    let group: any = {
      correction_index: [index],
      correction_index_date: [this.ad?.correction_index_date ? (index?.dates?.filter(item => item.start == this.ad?.correction_index_date)[0] || null) : null],
      correction_rounding: [this.ad?.correction_rounding ? this.adService.correction_rounding.filter(item => item.id == this.ad?.correction_rounding)[0] : this.adService.correction_rounding[0]],
      correction_auto: [this.ad?.correction_auto ? true : false]
    };

    let formBuilder = this.formBuilder.group(group, { emitEvent: false });

    this.setCorrectionIndexData(index, formBuilder);

    formBuilder.controls.correction_index.valueChanges.subscribe(result => {
      this.saveUnitsEditing();

      this.setCorrectionIndexData(result, formBuilder);

      if (!result?.index_id) {

        if (result.index_id != parseInt(this.ad?.correction_index) && parseInt(this.ad?.correction_index) > 0) {
          this.dialogRefIndex = this.dialog.open(DialogActionComponent,
            {
              data: {
                title: 'O quantitativo de índice das unidades serão zerados.',
                cancelTitle: 'Cancelar',
                okTitle: 'Continuar',
                okClass: 'btn-danger'
              }
            });

          this.dialogRefIndex.afterClosed().subscribe(result => {
            if (result) {
              this.clearUnitsIndex();
              this.setIndexEmpty();
            } else if (parseInt(this.ad?.correction_index) > 0) {
              this.setControlValue('correction_index', this.adService.indexes.find(item => item.index_id == this.ad?.correction_index), this.formGroup, { emitEvent: false });
            }
          });
        } else {
          this.clearUnitsIndex();
          this.setIndexEmpty();
        }

        /*
        if(this.getControlValue('correction_auto') !== false)
          this.setControlValue('correction_auto',false);

        if(this.getControlValue('correction_rounding') !== this.adService.correction_rounding[0])
          this.setControlValue('correction_rounding',this.adService.correction_rounding[0]);

          */
      }
    });

    formBuilder.controls.correction_index_date.valueChanges.subscribe(result => {
      this.saveUnitsEditing();
      this.adService.updateIndexMonth(result, (result) => this.updateIndex());
    });
    formBuilder.controls.correction_rounding.valueChanges.subscribe(result => {
      this.saveUnitsEditing();
      this.updateIndex();
    });

    return formBuilder;

  }

  setCorrectionIndexData(result, formBuilder) {
    if (result?.index_id) {
      this.adService.loadIndexes(result).then((dataSel: any) => {

        if (this.ad?.correction_index_date) {
          let dataSeleted = dataSel?.dates?.filter(item => item.start == this.ad?.correction_index_date)[0];
          formBuilder.controls.correction_index_date.setValue(dataSeleted, { emitEvent: false });
        }
      });
    }
  }

  clearUnitsIndex() {
    this.adUtils.data.units = this.adUtils.data.units.map(item => {
      item.amountIndexReadjustment = '0.000000';
      item.changed = true;
      //      delete item['amountIndex'];
      return item;
    });
    this.changed = true;
  }

  setIndexEmpty() {
    this.setControlValue('correction_index_date', null, this.formGroup, { emitEvent: false });
    this.setControlValue('correction_auto', false, this.formGroup, { emitEvent: false });
    this.setControlValue('correction_rounding', null, this.formGroup, { emitEvent: false });
  }

  saveUnitsEditing() {
    if (this.unitSel?.id) {
      this.saveUnits(false);
    }
  }

  updateIndex(updateIndexField = false, updateAmountField = false, readjustment = false) {

    let month = this.formGroup.controls.correction_index?.value?.index_id != 0 ? (this.formGroup.controls.correction_index_date?.value?.value || 0) : 0;
    let monthRate = this.formGroup.controls.correction_index?.value?.index_id != 0 ? (this.formGroup.controls.correction_index_date?.value?.rate || 0) : 0;
    let round = this.formGroup.controls.correction_index?.value?.index_id != 0 ? this.formGroup.controls.correction_rounding?.value : 0;

    //if(!(month || monthRate ))      return;

    let changed = false;
    let filters = this.getFormValues(this.formGroupFilter);

    this.adUtils.data.units = this.adUtils.data.units.map(unit => {

      if ((this.blockSel == 'all' || this.blockSel == unit.blockId) &&
        (!filters?.block?.length || filters?.block.indexOf(parseInt(unit.blockId)) > -1) &&
        (!filters?.unitType?.length || filters?.unitType.indexOf(parseInt(unit.blockTypeId)) > -1) &&
        (!filters?.status?.length || filters?.status.indexOf(parseInt(unit.status)) > -1) && (!this.unitSel?.id || this.unitSel?.id == unit?.id)
      ) {


        let amountFloat = parseFloat(unit.amount);
        let amountIndexFloat = month && unit?.amountIndex ? parseFloat(unit?.amountIndex) : false;

        if (readjustment) {
          switch (this.mode) {
            case 'percentage':
              if (!month && !amountIndexFloat)
                unit.amountReadjustment = this.valueReadjustment !== false ? (amountFloat + (amountFloat * (this.valueReadjustment / 100))).toFixed(2) : false;
              if (amountIndexFloat)
                unit.amountIndexReadjustment = this.valueReadjustment !== false ? (amountIndexFloat + (amountIndexFloat * (this.valueReadjustment / 100))).toFixed(6) : false;
              break;
            case 'amount':

              if (!amountIndexFloat && amountFloat > 0)
                unit.amountReadjustment = this.valueReadjustment !== false ? amountFloat + this.valueReadjustment : false;

              if (amountIndexFloat || (!month && unit?.amountIndex))
                unit.amountIndexReadjustment = this.valueReadjustment !== false ? (((parseFloat(unit.amount) + this.valueReadjustment) * parseFloat(unit.amountIndex)) / parseFloat(unit.amount)).toFixed(6) : false;

              break;
          }
        }

        if ((this.unitSel?.id && (updateIndexField || updateAmountField) && unit.id == this.unitSel?.id)) {
          if (updateIndexField) {
            //this.unitSel.amountIndexReadjustment = unit.amountIndexReadjustment = updateIndexField;

            unit.amountIndexReadjustment = this.unitSel.amountIndex = this.unitSel.amountIndexReadjustment = updateIndexField;
            unit.changed = true;

          }

          if (updateAmountField) {

            this.unitSel.amount = updateAmountField;
            unit.amountReadjustment = this.unitSel.amount;
            unit.changed = true;
          }

        }

        if ((!parseFloat(unit?.amountIndex) || (updateAmountField && (unit.id == this.unitSel?.id)))) {
          if (month)
            unit.amountIndexReadjustment = (parseFloat(unit?.amountReadjustment || unit.amount) / month).toFixed(6);
          else if (updateAmountField && (unit.id == this.unitSel?.id)) {
            unit.amountReadjustment = updateAmountField;
            unit.changed = true;
            changed = true;
          }
        }

        if (month && (unit?.amountIndexReadjustment || unit?.amountIndex) > 0)
          unit.amountReadjustment = this.adService.calcAmount((parseFloat(unit?.amountIndexReadjustment || unit?.amountIndex) * month).toFixed(2), round);

        //if(unit?.amountIndex != unit?.amountIndexReadjustment)
        //unit.amountIndexReadjustment = unit?.amountIndex;

        if (isNaN(unit.amountIndex) || unit.amountIndex == 'NaN')
          unit.amountIndex = '';

        if (isNaN(unit.amountReadjustment) || unit.amountReadjustment == 'NaN')
          unit.amountReadjustment = '';


        if (typeof unit.amountReadjustment !== 'string') {
          unit.amountReadjustment = unit.amountReadjustment.toString();
          if (unit.amountReadjustment.indexOf('.') == -1)
            unit.amountReadjustment += '.00';
        }

        if ((unit?.amountReadjustment && unit?.amountReadjustment != '0.00' && unit?.amountReadjustment !== unit.amount) || (unit?.amountIndexReadjustment && unit?.amountIndexReadjustment != '0.00' && unit?.amountIndexReadjustment != unit?.amountIndex)) {
          unit.changed = true;
          changed = true;
        }

        if ((this.unitSel?.id && unit.id == this.unitSel?.id)) {

          if (!updateIndexField && month) {
            this.setControlValue('amountIndex', typeof unit.amountIndexReadjustment == 'string' && unit.amountIndexReadjustment?.indexOf(',') == -1 ? this.setMaskMoney(unit.amountIndexReadjustment, 'separator.6') : unit.amountIndex, this.formGroupUnit, { emitEvent: false });
          }

          if (!updateAmountField && month)
            this.setControlValue('amount', typeof unit.amountReadjustment == 'string' && unit.amountReadjustment?.indexOf(',') == -1 ? this.setMaskMoney(unit.amountReadjustment) : unit.amount, this.formGroupUnit, { emitEvent: false });

          if (unit?.amountReadjustment)
            this.unitSel.amountReadjustment = unit.amountReadjustment;

          if (unit?.amountIndexReadjustment)
            this.unitSel.amountIndexReadjustment = unit.amountIndexReadjustment;
          //this.unitSel = unit;
        }
      }

      return unit;
    });

    if (!!this.adUtils.data.units.filter(item => item?.changed)?.length)
      this.changed = true;

    if (!this.unitSel?.id) {

      this.setBlockSel(false);


      if (!this.adUtils.data.units.filter(item => item?.changed)?.length)
        this.gs.message('Não houve modificações de valores');

      let amount = this.gs.convertMoneyToDouble(this.formGroupUnit.controls.amount?.value);
      let amountIndex: any = this.gs.convertMoneyToDouble(this.formGroupUnit.controls.amountIndex?.value);

      if (updateAmountField || (!amountIndex && month))
        amountIndex = (parseFloat(amount) / month).toFixed(6);

      if (updateIndexField)
        amount = (parseFloat(amountIndex) * month).toFixed(2);

      amount = this.adService.calcAmount(amount, round);


      if (!updateIndexField)
        this.setControlValue('amountIndex', this.setMaskMoney(amountIndex, 'separator.6'), this.formGroupUnit, { emitEvent: false });

      if (!updateAmountField)
        this.setControlValue('amount', this.setMaskMoney(amount), this.formGroupUnit, { emitEvent: false });
    }


    //if(!updateIndexField && !updateAmountField)      this.setUnitsByFloor();

  }

  setMaskMoney(nV, separator = 'separator.2') {
    const mask = new MaskPipe(this.ms);

    if (typeof nV !== 'string')
      nV = nV?.toString();

    if (nV?.indexOf(',') > -1)
      return nV;

    return mask.transform(!!nV?.length ? (nV?.indexOf('.') == -1 ? nV + ',000' : nV?.replace('.', ',') + '0') : '', separator, '.');
  }

  async setDefault() {

    await this.als.setLoaded(false, 'available');
    this.loading = true;
    await this.as.loadAd(this.id)
      .then(result => {
        this.ad = result;

        this.adUtils.data = this.ad.data;
        this.adUtils.setDefaultUtils();
        let category = this.gs.getFeatureCategory(this.ad.ad_category_id);
        let adType = this.adService.getFeatureTypes(category?.type_id)?.type;

        this.unitStatus = this.gs.arrayKeyCustom(this.gs.getStatus('unit', adType), 'id');
        this.unitStatusArray = this.gs.getStatus('unit', adType).map(item => { item.id = parseInt(item.id); return item; });

        this.setBlockSel(true, 'all');

        this.setDefaultSets();

        if (this.ad.data?.valueReference) {
          this.as.readjustmentMode = this.mode = 'index';
          const mask = new MaskPipe(this.ms);

          let valueReference = mask.transform(this.ad.data?.valueReference, 'separator.2', '.');
          setTimeout(() => this.indexReferenceField.nativeElement.value = valueReference, 200);
          this.amountReadjustment({ target: { value: this.ad.data?.valueReference } }, true);
        }
      })
      .finally(() => {
        this.als.setLoaded(true, 'available');
        this.loading = false;
      });
  }

  setBlockSel(refresh = true, id = this.blockSel) {
    if (id) {
      id = id?.detail?.value || id;

      let blockFilter = this.getControlValue('block', this.formGroupFilter);
      let unitTypeFilter = this.getControlValue('unitType', this.formGroupFilter);
      let statusFilter = this.getControlValue('status', this.formGroupFilter);

      this.tableBlockSelected = this.adUtils.generateTable(id == 'all' ? false : id, true, false, false)
        .filter(block => !blockFilter || !blockFilter?.length || blockFilter.indexOf(parseInt(block.id)) > -1)
        .map(block => {
          block.units = block.units.filter(unit => (!statusFilter || !statusFilter?.length || statusFilter.indexOf(parseInt(unit.status)) > -1) &&
            (!unitTypeFilter || !unitTypeFilter?.length || unitTypeFilter.indexOf(parseInt(unit.blockTypeId)) > -1)).map(unit => {
              if (isNaN(unit?.amount))
                unit.amount = '';

              return unit;
            })
            .map(unit => {
              unit.blockType = this.adUtils.getBlockTypesById(unit.blockTypeId);
              return unit;
            });
          return block;
        });

      this.blockSel = id;
      console.log(this.tableBlockSelected);
      if (refresh)
        this.amountReadjustment();
    }
  }

  setMode(event: any) {
    this.as.readjustmentMode = this.mode = event.value;

    if (this.mode == 'index')
      this.setBlockSel(true, 'all');
    else
      this.amountReadjustment();
  }

  selectBlur(event: any) {
    if (this.amountField?.nativeElement)
      setTimeout(() => this.amountField?.nativeElement.focus(), 200);
  }

  compareFn(c1: any, c2: any): boolean {
    if (c2 === null)
      return false;

    return c1 == c2;
  }

  compareFnId(c1: any, c2: any): boolean {
    if (c2 === null)
      return false;

    return c1 == c2 || c1?.id == c2?.id;
  }



  setTooltip() {

    $('[data-toggle="tooltip"]').tooltip('hide');
    $('.tooltip').remove();

    setTimeout(() =>
      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
      })
      , 300);
  }

  saveAll(next = false, unpublish = false) {
    this.as.indexConfig = this.getFormValues();

    if (!next && this.as.indexConfig?.correction_index?.index_id != 0 && this.as.indexConfig?.correction_index_date === null) {
      const dialogRef = this.dialog.open(DialogActionComponent,
        {
          data: {
            title: 'Selecione um mês de referência do índice (' + this.as.indexConfig?.correction_index?.title + ')',
            cancelNotShow: true
          }
        });

      dialogRef.afterClosed().subscribe(result => {
        this.monthReferenceField.open();
      });

      return;
    }

    if (!next && this.adUtils.data.units.filter(item => item.status == 11 && !parseFloat(item.amount) && (!parseFloat(item.amountReadjustment) || !item?.amountReadjustment))?.length) {
      const dialogRef = this.dialog.open(DialogActionComponent,
        {
          data: {
            title: 'Este empreendimento possui unidades disponíveis com valor zerado',
            okTitle: 'Ok, vou corrigir',
            cancelNotShow: true
          }
        });

      return;
    }

    if (!next && !this.adUtils.data.units.filter(item => item.status == 11)?.length) {
      const dialogRef = this.dialog.open(DialogActionComponent,
        {
          data: {
            title: 'Este empreendimento não possui unidades disponíveis',
            cancelTitle: 'Quero despublicar',
            okTitle: 'Manter como portfólio'
          }
        });

      dialogRef.afterClosed().subscribe(result => {
        this.saveAll(true, !result);
      });
      return;
    }

    this.als.setLoaded(false, 'availableSaveAll');
    this.as.mode = 'readjustment';
    this.as.saveAvailable(null, unpublish).then(result => {
      if (result) {
        this.as.setChanged(false);
        //this.setDefault();
        this.goBack();
      }
    }).finally(() => this.als.setLoaded(true, 'availableSaveAll'));
  }

  amountReadjustment(event: any = false, index = false) {

    let amount = index ? this.indexReadjustment : this.valueReadjustment;

    if (event) {
      amount = this.as.convertToFloat(event.target.value);
      if (index)
        this.indexReadjustment = !isNaN(amount) ? amount : false;
      else
        this.valueReadjustment = !isNaN(amount) ? amount : false;
    }


    if (this.valueReadjustment !== false)
      this.updateIndex(false, false, true);
    //this.as.calculateReadjustment(this.blockSel, this.mode, this.valueReadjustment, this.indexReadjustment, this.getFormValues(this.formGroupFilter));

    if (event?.key == 'Enter')
      event?.target?.blur();
  }

  closeDialog() {
    if (this.changed)
      this.openDialog({ action: 'close' });
    else
      this.goBack();
  }

  openDialog(data) {
    const dialogRef = this.dialog.open(DialogActionComponent,
      {
        disableClose: true,
        data: {
          title: 'Deseja salvar as alterações?',
          cancelTitle: 'Descartar',
          okTitle: 'Salvar'
        }
      });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.saveAll();
      else
        this.goBack();
    });
  }

  getUnitTypesByBlockId(blockId, key: any = false) {
    var r = [];

    if (!this.ad.data.unitTypes.length)
      return r;

    var ids = this.ad.data.unitTypes.filter(item => item['blockId'] == blockId);

    for (var k in ids)
      if (ids.hasOwnProperty(k))
        r.push(key === false ? ids[k] : ids[k][key]);

    return r;
  }

  setFieldsSubscribes(form) {
    form.controls.amountIndex.valueChanges.subscribe(result => {
      //this.unitsDS[0].amountIndex = this.gs.convertMoneyToDouble(result);

      if (result !== null)
        this.updateIndex(result);
    });
    form.controls.amount.valueChanges.subscribe(result => {
      //this.unitsDS[0].amount = this.gs.convertMoneyToDouble(result);

      if (result !== null)
        this.updateIndex(false, result);
    });
  }

  editUnit(event, unit) {
    event.stopPropagation();

    if (this.unitSel?.id == unit?.id)
      return;

    if (this.unitSel?.id && this.unitSel?.id != unit?.id && this.formGroupUnit.dirty)
      this.saveUnits(false);

    this.unitSel = deepCopy(unit);
    this.unitSel.status = this.unitStatusArray.filter(item => item.id == parseInt(unit.status))[0];

    this.unitSel.amount = typeof this.unitSel?.amountReadjustment != 'undefined' && this.unitSel?.amountReadjustment != '' ? (this.unitSel?.amountReadjustment?.indexOf(',') == -1 ? this.setMaskMoney(this.unitSel?.amountReadjustment) : this.unitSel?.amountIndexReadjustment) : (typeof this.unitSel?.amount == 'string' && this.unitSel?.amount?.indexOf(',') == -1 ? this.setMaskMoney(this.unitSel?.amount) : this.unitSel?.amount);

    this.unitSel.amountOld = typeof this.unitSel?.amountOld == 'string' && this.unitSel?.amountOld?.indexOf(',') == -1 ? this.setMaskMoney(this.unitSel?.amountOld) : this.unitSel?.amountOld;

    this.unitSel.amountIndex = this.unitSel?.amountIndexReadjustment ? (this.unitSel?.amountIndexReadjustment && this.unitSel?.amountIndexReadjustment?.indexOf(',') == -1 ? this.setMaskMoney(this.unitSel?.amountIndexReadjustment) : this.unitSel?.amountIndexReadjustment) : (typeof this.unitSel?.amountIndex == 'string' && this.unitSel?.amountIndex?.indexOf(',') == -1 ? this.setMaskMoney(this.unitSel?.amountIndex) : this.unitSel?.amountIndex);

    Object.entries(this.formGroupUnitFields).map(control => {
      if (typeof this.unitSel[control[0]] == 'undefined')
        this.unitSel[control[0]] = control[1][0];
    });

    this.setFormValues(this.unitSel, this.formGroupUnit, { emitEvent: false });
    this.formGroupUnit.markAsPristine();

    this.setTooltip();
  }

  saveUnits(event) {

    let data: any = {};
    for (const field in this.formGroupUnit.controls) {
      if (this.formGroupUnit.controls.hasOwnProperty(field)) {
        data[field] = this.updateUnitsDataSave(field, this.formGroupUnit.controls[field].value);
      }
    }

    let changed = 0;

    let hasError = false;

    this.adUtils.data.units = this.adUtils.data.units.map((unit: any) => {
      if (unit?.id == this.unitSel?.id) {

        if (data.amount != unit.amount) {
          data.amountReadjustment = data.amount;
          delete data.amount;
        }
        if (data.amountIndex != unit.amountIndex) {
          data.amountIndexReadjustment = data.amountIndex;
          delete data.amountIndex;
        }

        Object.keys(data).map(key => {
          if (data[key] != unit[key]) {
            changed++;
            data.changed = true;
          }
        });

        unit = { ...unit, ...data };

        if (unit.status == 11 && !parseFloat(unit.amount))
          hasError = true;
      }
      return unit;
    });


    if (hasError)
      this.gs.error(false, 'Ops! Unidade disponível com valor de venda zerado');

    this.setBlockSel(false);

    if (changed > 0)
      this.changed = true;

    this.unitSel = {};

    this.setTooltip();
  }

  cancelItemChange(item, event) {
    event?.stopPropagation();

    item.changed = -1;

    this.setTooltip();
  }
  reativeCancelItemChange(item, event) {
    event?.stopPropagation();
    item.changed = true;

    this.setTooltip();
  }

  updateUnitsDataSave(field, value: any = null) {
    if (typeof field === 'string') {

      switch (field) {
        case 'garage':
        case 'garageMax':
          if (!isNaN(parseInt(value)))
            value = parseInt(value);
          break;
        case 'blockTypeId':
        case 'status':
          if (value?.id)
            value = value.id;

          if (!isNaN(parseInt(value)))
            value = parseInt(value);
          break;
        case 'privateArea':
        case 'totalArea':
          if (value && !!value.length)
            value = value.replace('.', ',');
          break;
        case 'amount':
        case 'amountOld':
        case 'amountIndex':

          if (value && !!value.length && value.indexOf(',') > -1)
            value = value.replace(/\./gi, '').replace(',', '.');
          break;
      }

      return value;

    } else if (typeof field === 'object') {

      let data: any = {};
      Object.entries(field).forEach(([k, b]: any) => {
        data[k] = this.updateUnitsDataSave(k, field[k]);
      });

      if (!data?.id)
        data.id = 1;

      return data;

    } else {

      return value;
    }
  }

}

